import { render, staticRenderFns } from "./lista-precos.vue?vue&type=template&id=64a14302&scoped=true&"
import script from "./lista-precos.vue?vue&type=script&lang=js&"
export * from "./lista-precos.vue?vue&type=script&lang=js&"
import style0 from "./lista-precos.vue?vue&type=style&index=0&id=64a14302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a14302",
  null
  
)

export default component.exports